export const bulkUploadI18n = {
  bulkUploadTemplateFileName: 'template-file-name-from-api',
  stepOneHeadingDownloadTemplate: 'step-1-heading',
  stepOneExplainer: 'step-1-explainer',
  stepOneBtnDownloadTemplate: 'step-1-btn-download',
  stepTwoHeadingFillOutTemplate: 'step-2-heading',
  stepThreeHeadingUpload: 'step-3-heading',
  stepThreeExplainer: 'step-3-explainer',
  stepThreeFileTypeRestrictions: 'step-3-file-restrictions',
  stepThreeBtnUploadSpreadsheet: 'step-3-btn-upload',
  stepThreeBtnBrowse: 'step-3-btn-browse',
  viewUploadedItems: 'view-uploaded-items',
  errMaxSizeExceeded: 'err-max-size-exceeded',
  errTemplateFailed: 'err-occurred-in-uploaded-template',
  statusUploading: 'field-is-uploading',
};
